/**
 * Contact activity actions.
 */

import request from '../../utils/request';

const PREFIX = '[ACTIVITY]';

export const FETCH_ALL_ACTIVITIES_REQUEST = `${PREFIX} FETCH_ALL_ACTIVITY_REQUEST`;
export const FETCH_ALL_ACTIVITIES_SUCCESS = `${PREFIX} FETCH_ALL_ACTIVITY_SUCCESS`;
export const FETCH_ALL_ACTIVITIES_FAILURE = `${PREFIX} FETCH_ALL_ACTIVITY_FAILURE`;

const fetchAllActivitiesRequest = () => ({
  type: FETCH_ALL_ACTIVITIES_REQUEST,
});

const fetchAllActivitiesSuccess = payload => ({
  payload,
  type: FETCH_ALL_ACTIVITIES_SUCCESS,
});

const fetchAllActivitiesFailure = payload => ({
  payload,
  type: FETCH_ALL_ACTIVITIES_FAILURE,
});

export const fetchContactActivity = (organizationUuid, contactUuid) => dispatch => {
  dispatch(fetchAllActivitiesRequest());

  return request
    .get(`/v1/crm/${organizationUuid}/contacts/${contactUuid}/activity/`)
    .then(({ data }) => {
      dispatch(fetchAllActivitiesSuccess(data));

      return data;
    })
    .catch(({ response: { data } = {} }) => {
      dispatch(fetchAllActivitiesFailure(data));

      throw data;
    });
};
